import { Component, OnInit } from '@angular/core';

import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { UserService } from '../user.service';

@Component({
  selector: 'app-user-task-list',
  templateUrl: './user-task-list.component.html',
  styleUrls: ['./user-task-list.component.scss']
})
export class UserTaskListComponent implements OnInit {
  
  userTasks: any;
  dataSource: MatTableDataSource<any>;

  constructor(private userService: UserService,
              private router: Router) {
                this.dataSource = new MatTableDataSource();
              }

  ngOnInit(): void {
    this.reloadData();
  }

  reloadData(): void {
    this.userService.getUserTasks().subscribe(x => {
      this.userTasks =  x;
    });
  }

  deleteMaterial(id: number): void {}

  materialDetails(id: number): void{
    this.router.navigate(['update-user-task', id]);
  }

}

